import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const ArrowDownSolid: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'arrow-down-solid'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <g clipPath="url(#clip0_25073_8210)" id={label}>
          <path
            d="M16.9241 10H7.07592C6.1193 10 5.64021 11.11 6.31665 11.7592L11.2407 16.6982C11.6601 17.1006 12.3399 17.1006 12.7593 16.6982L17.6833 11.7592C18.3598 11.11 17.8807 10 16.9241 10Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_25073_8210">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </AccessibleIcon.Root>
  )
}

export default ArrowDownSolid
